import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';
import { SecondaryHeaderLoader } from 'src/domains/layouts/shared/loaders';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { css, SerializedStyles } from '@emotion/react';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';

export const RaceSliderItemLoaderWrapper = styled('div', { label: 'RaceSliderItemLoaderWrapper' })`
    flex: 0 0 300px;
    user-select: none;
    width: 300px;
`;

interface RaceSliderItemLoaderPropsType {
    variant: DefaultComponentVariantType | null;
}

const setRaceSliderHeaderLoader = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            border-radius: ${theme.star.radius.medium};
            margin-bottom: 8px;
        `;
    }
    return css`
        border-radius: ${theme.star.radius.medium} ${theme.star.radius.medium} 0 0;
    `;
};

export const RaceSliderHeaderLoader = withConfig(theme => styled(SecondaryHeaderLoader, { label: 'RaceSliderHeaderLoader' })<RaceSliderItemLoaderPropsType>`
    ${({ variant }): SerializedStyles => setRaceSliderHeaderLoader(variant, theme)}
`);

const setRaceSliderListItem = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            border-radius: ${theme.star.radius.medium};
            margin-bottom: 4px;
            &:last-of-type {
                height: 32px;
            }
        `;
    }
    return css`
        border-bottom: 1px solid ${theme.star.racingNextOff.raceBox.borderColor};
        &:last-of-type {
            border-radius: 0 0 ${theme.star.radius.medium} ${theme.star.radius.medium};
            height: 40px;
        }
    `;
};

export const RaceSliderListItem = withConfig(theme => styled('li', { label: 'RaceSliderListItem' })<RaceSliderItemLoaderPropsType>`
    align-items: center;
    background-color: ${theme.star.selectionsGroup.bgColor};
    display: flex;
    flex-flow: row nowrap;
    height: 48px;
    ${({ variant }): SerializedStyles => setRaceSliderListItem(variant, theme)}
`);

